module.exports = __webpack_public_path__ + "media/images/icons/star-58eb84e990e1a0f17c528e11c1edb89d.svg";